import React, { useState } from "react";
import "./auth.scss";

import Icon from "../../components/appShell/icons";
import Snackbar from "../../components/snackbar/snackbar";

// The curator and bidder sign-in screens were two copies of the same markup
// down to the class names. They are one form page now, told apart only by the
// role it signs you in as.
//
// It follows the form-page rule: heading, a muted line saying what the form is
// for, then a single inset card holding every field, with labels above the
// controls and the primary action at the end.
export default function AuthLayout({
  role,
  blurb,
  onSubmit,
  error,
  showError,
  setShowError,
}) {
  const [userQuery, setUserQuery] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);

  return (
    <div className="auth-page">
      <Snackbar
        show={showError}
        setShow={setShowError}
        errorMsg={error}
        location={{ vertical: "bottom", horizontal: "center" }}
      />

      <main className="auth-panel">
        <div className="auth-mark">A</div>

        <h1 className="au-heading auth-heading">Sign in</h1>
        <p className="au-subheading auth-sub">{blurb}</p>

        <form
          className="au-card auth-card"
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit({ userQuery, password });
          }}
        >
          <div className="auth-field">
            <label className="au-label" htmlFor="auth-user">
              User ID
            </label>
            <input
              id="auth-user"
              className="auth-input"
              type="text"
              autoFocus
              autoComplete="username"
              placeholder="Your user ID"
              value={userQuery}
              onChange={(e) => setUserQuery(e.target.value)}
            />
          </div>

          <div className="auth-field">
            <label className="au-label" htmlFor="auth-pass">
              Password
            </label>
            <div className="auth-input-wrap">
              <input
                id="auth-pass"
                className="auth-input"
                type={showPass ? "text" : "password"}
                autoComplete="current-password"
                placeholder="Your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="au-icon-btn auth-eye"
                onClick={() => setShowPass((v) => !v)}
                aria-label={showPass ? "Hide password" : "Show password"}
              >
                <Icon name={showPass ? "eyeOff" : "eye"} size={17} />
              </button>
            </div>
            <p className="au-hint">
              Issued by the auction admin along with your {role} account.
            </p>
          </div>

          <button type="submit" className="au-btn primary block auth-submit">
            Sign in as {role}
          </button>
        </form>
      </main>
    </div>
  );
}
